import { render } from "./StoppageAddUpdateModal.vue?vue&type=template&id=baa73dc6"
import script from "./StoppageAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./StoppageAddUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__